var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0376 4H8.96243C8.87489 4 8.7882 4.01724 8.70731 4.05075C8.62643 4.08425 8.55293 4.13336 8.49103 4.19526L4.19526 8.49103C4.13336 8.55293 4.08425 8.62643 4.05075 8.70731C4.01724 8.7882 4 8.87489 4 8.96243V15.0376C4 15.1251 4.01724 15.2118 4.05075 15.2927C4.08425 15.3736 4.13336 15.4471 4.19526 15.509L8.49103 19.8047C8.55293 19.8666 8.62643 19.9157 8.70731 19.9493C8.7882 19.9828 8.87489 20 8.96243 20H15.0376C15.1251 20 15.2118 19.9828 15.2927 19.9493C15.3736 19.9157 15.4471 19.8666 15.509 19.8047L19.8047 15.509C19.8666 15.4471 19.9157 15.3736 19.9493 15.2927C19.9828 15.2118 20 15.1251 20 15.0376V8.96243C20 8.87489 19.9828 8.7882 19.9493 8.70731C19.9157 8.62643 19.8666 8.55293 19.8047 8.49103L15.509 4.19526C15.4471 4.13336 15.3736 4.08425 15.2927 4.05075C15.2118 4.01724 15.1251 4 15.0376 4Z",
  stroke: "#18372A",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: -1,
  x2: 6,
  y2: -1,
  transform: "matrix(-4.37113e-08 -1 -1 4.37113e-08 11 14)",
  stroke: "#18372A",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  rx: 1,
  transform: "matrix(1 0 0 -1 11 17)",
  fill: "#18372A"
});

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9ea4d9f4dbb71bc00a5a000f58449cd5.svg";
export { ForwardRef as ReactComponent };